import { useMemo } from "react";

export function useCut<T>(list: T[], cutCount = list.length) {
  const firstPart = useMemo(() => list.slice(0, cutCount), [list, cutCount]);
  const secondPart = useMemo(() => list.slice(cutCount, list.length), [list, cutCount]);

  return [firstPart, secondPart];
}
